/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { closelightbox } from "../../util/Functions";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const AlboCardCIH = (props) => {
	const [zPos, setZPos] = useState(45)
  const [disabled, setDisabled] = useState(true);
  const [codeCountry, setCodeCountry] = useState("");
  const [errCodeCountry, setErrCodeCountry] = useState("");
  const [form, setForm] = useState({
    personalization: { company_name: "", contact_phone: "", contact_email: "", type_perso: ""},
    shipment: {
      address: { zip: "", town: "", street: "", intnum: "", state: "", locality: "", extnum: "", reference: "", country: "" },
    },
    customer_uuid: "",
    size: "",
    partner_uuid: "alboCard",
    priority: "normal",
  });
  const [errors, setErrors] = useState({
    personalization: {
      company_name: "",
      contact_phone: "",
      contact_email: "",
      type_perso: "",
    },
    shipment: {
      address: { zip: "", town: "", street: "", state: "", locality: "", extnum: "", reference: "", country: "" },
    },
    size: "",
  });
  const history = useHistory();
  const [locality, setLocality] = useState([]);
  const [typePersoCat, setTypePersoCat] = useState([]);
  const [defaultCountry, setDefaultCountry] = useState("");
  useEffect(() => {
    for (let c in props.catalogs.country) {
      if (props.catalogs.country[c].v === "Mexico" || props.catalogs.country[c].v === "México") {
        setDefaultCountry(props.catalogs.country[c].k);
        break;
      }
    }

    let roles = localStorage.config && JSON.parse(localStorage.config)["idRol"] ? [JSON.parse(localStorage.config)["idRol"]] : [];
    const typePersoCat = new Set();
    for (let r in roles) {
      for (let c in props.customCard) {
        const cardCustomization = props.customCard[c];
        if ((cardCustomization.m?.[0]?.requester && cardCustomization.m?.[0]?.requester.indexOf(roles[r]) != -1) || roles[r] == "inext-role-IT-Ops") {
          typePersoCat.add(cardCustomization);
        }
      }
    }
    setTypePersoCat(Array.from(typePersoCat));
  }, []);

  const getCatalog = async (name, zip) => {
    props.changeLoader(true);
		setZPos(-1)

    let data = {
      catalog: {
        id: name,
        filters: [
          {
            key: zip,
          },
        ],
      },
    };

    let catalog = await API.service( "getCatalog", data, props.pos, props.changeAlert, props.changeLoader, history );
    props.changeLoader(false);
		setZPos(45)
    return catalog;
  };

  const send = async () => {
    props.changeLoader(true);
		setZPos(-1)

    let f = form;

    f.customer_uuid = props.data.uuid;
    f.shipment.address.country = defaultCountry;
    f.personalization.contact_phone = `+${codeCountry}${f.personalization.contact_phone}`;

    let response = await API.service( "alboCardCIH", f, props.pos, props.changeAlert, props.changeLoader, history );
    if (response.status === 200) {
      if (response.data.data.response == "OK") {
        props.changeAlert( true, "success", "Tarjetas solicitadas correctamente. suiteCase: " + response.data.data.widget[0].content.suit_case );
        closelightbox();
      } else {
        f.personalization.contact_phone = f.personalization.contact_phone.replace(`+${codeCountry}`, "");
        setForm(JSON.parse(JSON.stringify(f)));
      }
    }
    props.changeLoader(false);
		setZPos(45)
  };

  const validateForm = (f, err, code, error) => {
    if ( f.personalization.company_name && f.personalization.contact_phone && f.personalization.contact_email && f.personalization.type_perso && f.shipment.address.zip && f.shipment.address.town && f.shipment.address.street && f.shipment.address.state && f.shipment.address.locality && f.shipment.address.extnum && f.shipment.address.reference && f.shipment.address.reference && f.size &&
      !err.personalization.company_name && !err.personalization.contact_phone && !err.personalization.contact_email && !err.personalization.type_perso && !err.shipment.address.zip && !err.shipment.address.town && !err.shipment.address.street && !err.shipment.address.state && !err.shipment.address.locality && !err.shipment.address.extnum && !err.shipment.address.reference && !err.shipment.address.reference && !err.size && !error &&
      code ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const change = async (object, field, e) => {
    let f = form;
    let err = errors;
    let cc = codeCountry;
    let ecc = errCodeCountry;
    if (object == "address") {
      if (field == "zip") {
        if (!isNaN(e.target.value)) {
          f.shipment.address[field] = e.target.value;
        }
      } else {
        f.shipment.address[field] = e.target.value;
      }
      if (!e.target.value) {
        err.shipment.address[field] = "Dato obligatorio";
      } else {
        err.shipment.address[field] = "";
      }

      if (field == "zip") {
        if (f.shipment.address.zip.length < 5) {
          err.shipment.address.zip = "El código postal debe ser de 5 digitos";
        } else {
          err.shipment.address.zip = "";
          let catalog = await getCatalog("zip", e.target.value);
          if (catalog.status == 200 && catalog.data.data.response == "OK") {
            let cat = [];
            f.shipment.address.state = "";
            f.shipment.address.town = "";
            for (let i = 0; i < catalog.data.data.catalog.length; i++) {
              cat.push(catalog.data.data.catalog[i]["m"][0].township);
            }
            setLocality(JSON.parse(JSON.stringify(cat)));
            f.shipment.address.state = catalog.data.data.catalog[0]?.["m"]?.[0]?.state_key;
            f.shipment.address.town = catalog.data.data.catalog[0]?.["m"]?.[0]?.municipality;
            f.shipment.address.locality = "";
            errors.shipment.address.locality = "";
          }
        }
      }
    }

    if (object == "personalization") {
      f.personalization[field] = e.target.value;
      if (!e.target.value) {
        err.personalization[field] = "Dato obligatorio";
      } else {
        err.personalization[field] = "";
      }
    }

    if (!object) {
      if (field == "size") {
        if (!isNaN(e.target.value)) {
          f.size = e.target.value;
        }
      } else {
        f[field] = e.target.value;
      }

      if (!e.target.value) {
        err[field] = "Dato obligatorio";
      } else {
        err[field] = "";
      }

      if (field == "size") {
        if (e.target.value <= 0 ) {
          err.size = "Número de tarjetas debe ser 1 a 5000";
        } else {
          err.size = "";
        }
      }
    }

    setErrors(JSON.parse(JSON.stringify(err)));
    setForm(JSON.parse(JSON.stringify(f)));
    validateForm(f, err, cc, ecc);
  };

  const changeCode = (e) => {
    let f = form;
    let er = errors;
    let error = errCodeCountry;
    setCodeCountry(e.target.value);
    if (!e.target.value) {
      error = "Dato obligatorio";
    } else {
      error = "";
    }
    setErrCodeCountry(error);
    validateForm(f, er, e.target.value, error);
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
					Solicitud de Tarjetas
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent>					
          <Grid container spacing={2} >
						<Grid item xs={12} style={{fontWeight: "bolder"}}>
							Datos de Envío         
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Nombre de entidad / persona quien recibe" value={form.personalization.company_name} onChange={change.bind(this, "personalization", "company_name")} size="small" fullWidth error={errors.personalization.company_name !== ""} helperText={errors.personalization.company_name ? errors.personalization.company_name : ''} inputProps={{ maxLength: 21 }}/>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Código Postal" value={form.shipment.address.zip} onChange={change.bind(this, "address", "zip")} size="small" fullWidth error={errors.shipment.address.zip !== ""} helperText={errors.shipment.address.zip ? errors.shipment.address.zip : ''} inputProps={{ maxLength: 5}}/>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Estado" value={form.shipment.address.state} name="address.state" disabled select size="small" fullWidth error={errors.shipment.address.state !== ""} helperText={errors.shipment.address.state ? errors.shipment.address.state : ''} >
								{props.catalogs.states.map((item, index) => (
									<MenuItem key={`state-${index}`} value={item.k}>{item.v}</MenuItem>
                ))}
							</TextField>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Alcaldia / Municipio" value={form.shipment.address.town} disabled size="small" fullWidth error={errors.shipment.address.town !== ""} helperText={errors.shipment.address.town ? errors.shipment.address.town : ''}/>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Colonia" value={form.shipment.address.locality} select onChange={change.bind(this, "address", "locality")} size="small" fullWidth error={errors.shipment.address.locality !== ""} helperText={errors.shipment.address.locality ? errors.shipment.address.locality : ''} >
								{locality?.map((item, index) => (
                  <MenuItem key={`address-${index}`} value={item}>{item}</MenuItem>
                ))}
							</TextField>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Calle" value={form.shipment.address.street} onChange={change.bind(this, "address", "street")} size="small" fullWidth error={errors.shipment.address.street !== ""} helperText={errors.shipment.address.street ? errors.shipment.address.street : ''} inputProps={{ maxLength: 50 }}/>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="No. ext." value={form.shipment.address.extnum} onChange={change.bind(this, "address", "extnum")} size="small" fullWidth error={errors.shipment.address.extnum !== ""} helperText={errors.shipment.address.extnum ? errors.shipment.address.extnum : ''} inputProps={{ maxLength: 25 }}/>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="No. int." value={form.shipment.address.intnum} onChange={change.bind(this, "address", "intnum")} size="small" fullWidth inputProps={{ maxLength: 25 }}/>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Referencia" value={form.shipment.address.reference} onChange={change.bind(this, "address", "reference")} size="small" fullWidth error={errors.shipment.address.reference !== ""} helperText={errors.shipment.address.reference ? errors.shipment.address.reference : ''} inputProps={{ maxLength: 27 }}/>
            </Grid>

						<Grid item xs={6} sx={{ display: "flex" }}>
							<TextField
								label="Código País"	value={codeCountry}	onChange={changeCode.bind(this)} select size="small"	sx={{ marginRight: "10px" }} style={{ width: "45%" }} InputLabelProps={{ shrink: true }}	error={errCodeCountry !== ""} helperText={errCodeCountry ? errCodeCountry : ''}>
								{props.catalogs.country.map((item, index) => {
									return (
										<MenuItem key={`state-${index}`} value={item.m[0].dial}>
											(+{item.m[0].dial}) {item.m[0].code2}
										</MenuItem>
									);
								})}
							</TextField>
							<TextField
								label="Teléfono" value={form.personalization.contact_phone} onChange={change.bind(this, "personalization", "contact_phone")} size="small"style={{ width: "55%" }} InputProps={{ style: { height: "40px"}}} error={errors.personalization.contact_phone !== ""} helperText={errors.personalization.contact_phone ? errors.personalization.contact_phone : ''}/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								label="Email"	value={form.personalization.contact_email}	onChange={change.bind(this, "personalization", "contact_email")}	size="small"	fullWidth	error={errors.personalization.contact_email !== ""} helperText={errors.personalization.contact_email ? errors.personalization.contact_email : ''}/>
						</Grid>

						<Grid item xs={12} style={{fontWeight: "bolder"}}>
							<hr />
							Tarjetas a Solicitar        
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Cantidad" value={form.size} onChange={change.bind(this, "", "size")} size="small" fullWidth error={errors.size !== ""} helperText={errors.size ? errors.size : ''} inputProps={{ maxLength: 4, minLength: 1}}/>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Tipo Personalización" value={form.personalization.type_perso} select onChange={change.bind(this, "personalization", "type_perso")} size="small" fullWidth error={errors.personalization.type_perso !== ""} helperText={errors.personalization.type_perso ? errors.personalization.type_perso : ''} >
								{typePersoCat?.map((item, index) => (
                  <MenuItem key={`type-${index}`} value={item.k}>{item.v}</MenuItem>
                ))}
							</TextField>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>    
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
          <Button disabled={disabled} variant="contained" onClick={send.bind(this)} >Solicitar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog> 
  );
};

export default AlboCardCIH;